module.exports = __webpack_public_path__ + "static/media/shield-active.76ed30ce.svg";